// src/components/AllRecipes.js
import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import RecipeCard from "./RecipeCard";
import "../styles/allrecipes.css";

export default function AllRecipes() {
  const [recipes, setRecipes] = useState([]);
  const [categories, setCategories] = useState([]);

  const [search, setSearch] = useState("");
  const [filterCat, setFilterCat] = useState("all");
  const [filterTaste, setFilterTaste] = useState("all");

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const { data: recipeData } = await supabase
        .from("recipes")
        .select("*, recipe_images(*)")
        .order("created_at", { ascending: false });

      const { data: cats } = await supabase
        .from("categories")
        .select("*")
        .order("name", { ascending: true });

      setRecipes(recipeData || []);
      setCategories(cats || []);
      setLoading(false);
    }

    load();
  }, []);

  // ---------------- FILTERING ------------------

  const filtered = recipes.filter((r) => {
    const text = search.toLowerCase();

    const matchesText =
      r.title?.toLowerCase().includes(text) ||
      r.description?.toLowerCase().includes(text) ||
      r.ingredients?.toLowerCase().includes(text);

    const matchesCat = filterCat === "all" ? true : r.category === filterCat;

    const matchesTaste =
      filterTaste === "all"
        ? true
        : (r.taste || r.type) === filterTaste;

    return matchesText && matchesCat && matchesTaste;
  });

  return (
    <div className="all-wrap">
      <h1 className="all-title">Tražilica recepata</h1>

      {/* FILTER BAR */}
      <div className="all-filters">
        <input
          className="all-input"
          placeholder="🔍 Pretraži recepte..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <select
          className="all-input"
          value={filterCat}
          onChange={(e) => setFilterCat(e.target.value)}
        >
          <option value="all">Sve kategorije</option>
          {categories.map((c) => (
            <option key={c.id} value={c.slug}>
              {c.name}
            </option>
          ))}
        </select>

        <select
          className="all-input"
          value={filterTaste}
          onChange={(e) => setFilterTaste(e.target.value)}
        >
          <option value="all">Svi okusi</option>
          <option value="slatko">Slatko</option>
          <option value="slano">Slano</option>
        </select>
      </div>

      {/* GRID */}
      {loading ? (
        <p className="loading">Učitavanje...</p>
      ) : filtered.length === 0 ? (
        <p className="no-results">Nema pronađenih recepata.</p>
      ) : (
        <div className="all-grid">
          {filtered.map((r) => (
            <RecipeCard key={r.id} recipe={r} />
          ))}
        </div>
      )}
    </div>
  );
}
